// extracted by mini-css-extract-plugin
export default {"whiteColor":"#fff","blackColor":"#121212","grayColor":"gray","lightGrayColor":"#ccc","subItemColor":"#3f51b5","errorColor":"#d32f2f","middleGrayColor":"silver"};